module.exports = __webpack_public_path__ + "img/6.f1de9e21.png";